<template>
  <ul class="list-group">
    <router-link to="/home" class="list-group-item" active-class="active"><i class="far fa-credit-card mr-2"></i> Meus
      Cartões</router-link>
    <router-link v-show="user.profile == 'HOLDER'" to="/pagamento" class="list-group-item" active-class="active"><i
        class="fas fa-file-invoice-dollar mr-2"></i> Pagamentos</router-link>
    <router-link v-show="user.profile == 'HOLDER'" to="/assinatura" class="list-group-item" active-class="active"><i
        class="fas fa-bars mr-2"></i> Assinatura</router-link>
    <router-link to="/editar-perfil" class="list-group-item" active-class="active"><i class="fas fa-tools mr-2"></i>
      Configurações</router-link>
  </ul>
</template>

<script>
import { EventBus } from '@/eventBus';

export default {
  mounted() {
    this.menuRoles()
  },
  created() {
    EventBus.$on('assinatura-selecionada', this.handleAssinaturaSelecionada);
  },
  data() {
    return {
      user: {
        profile: null
      },
      subscription: {
        status: 'OK'
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('assinatura-selecionada', this.handleAssinaturaSelecionada);
  },
  methods: {
    menuRoles() {
      this.user.profile = localStorage.getItem("profile");
    },
    handleAssinaturaSelecionada(id) {
      this.carregarAssinatura(id);
    },
    carregarAssinatura(id) {
      if (id !== undefined) {
        this.$clubApi
          .get("/subscription/load/" + id)
          .then(response => this.subscription = response.data.object)
          .finally(() => NProgress.done());
      }
    },
  }
}   
</script>

